var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
var SvgTrophyicon = function SvgTrophyicon(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: "1.5em",
    height: "1.5em",
    fill: "none",
    viewBox: "0 0 24 24"
  }, props), _path || (_path = /*#__PURE__*/React.createElement("path", {
    fill: "currentColor",
    d: "M11 19v-3.1a5.4 5.4 0 0 1-2.187-1.037A4.5 4.5 0 0 1 7.4 12.95a4.85 4.85 0 0 1-3.137-1.637A4.82 4.82 0 0 1 3 8V7q0-.824.588-1.412A1.93 1.93 0 0 1 5 5h2q0-.824.588-1.412A1.93 1.93 0 0 1 9 3h6q.825 0 1.413.588T17 5h2q.825 0 1.413.588T21 7v1a4.8 4.8 0 0 1-1.263 3.313A4.85 4.85 0 0 1 16.6 12.95q-.45 1.15-1.412 1.913A5.35 5.35 0 0 1 13 15.9V19h3q.425 0 .713.288T17 20q0 .424-.288.713A.96.96 0 0 1 16 21H8a.97.97 0 0 1-.712-.288A.97.97 0 0 1 7 20q0-.424.288-.712A.97.97 0 0 1 8 19zm-4-8.2V7H5v1q0 .95.55 1.713T7 10.8m5 3.2q1.25 0 2.125-.875A2.9 2.9 0 0 0 15 11V5H9v6q0 1.25.875 2.125A2.9 2.9 0 0 0 12 14m5-3.2q.9-.326 1.45-1.088Q19 8.948 19 8V7h-2z"
  })));
};
export default SvgTrophyicon;